// Copyright 1999-2017. Plesk International GmbH. All rights reserved.

import { createElement, Fragment } from '../../utils';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { CLS_PREFIX } from '../../constants';
import Checkbox from '../Checkbox';
import FormField from '../FormField';

import '../../helpers/base.less';
import './FormFieldCheckbox.less';

/**
 * `FormFieldCheckbox` component.
 */
const FormFieldCheckbox = ({
    baseClassName,
    className,
    disabled,
    label,
    required,
    checkedValue,
    uncheckedValue,
    ...props
}) => (
    <FormField className={classNames(baseClassName, className)} label={null} {...props}>
        {({ getId, getName, getValue, setValue, getRequiredMark }) => (
            <Fragment>
                <input type="hidden" name={getName()} value={uncheckedValue} />
                <Checkbox
                    checked={getValue() === checkedValue}
                    onChange={checked => setValue(checked ? checkedValue : uncheckedValue)}
                    inputProps={{ id: getId(), name: getName(), value: checkedValue }}
                    disabled={disabled}
                >
                    {label} {required ? getRequiredMark() : null}
                </Checkbox>
            </Fragment>
        )}
    </FormField>
);

FormFieldCheckbox.propTypes = {
    /**
     * Disabled state of field.
     */
    disabled: PropTypes.bool,
    /**
     * Custom checked value. Default is boolean true.
     */
    checkedValue: PropTypes.oneOfType([
        PropTypes.bool,
        PropTypes.string,
    ]),
    /**
     * Custom unchecked value. Default is boolean false.
     */
    uncheckedValue: PropTypes.oneOfType([
        PropTypes.bool,
        PropTypes.string,
    ]),
    /**
     * @ignore
     */
    label: PropTypes.any,
    /**
     * @ignore
     */
    required: PropTypes.bool,
    /**
     * @ignore
     */
    className: PropTypes.string,
    /**
     * @ignore
     */
    baseClassName: PropTypes.string,
};

FormFieldCheckbox.defaultProps = {
    disabled: false,
    checkedValue: true,
    uncheckedValue: false,
    label: undefined,
    required: false,
    className: undefined,
    baseClassName: `${CLS_PREFIX}form-field-checkbox`,
};

export default FormFieldCheckbox;



// WEBPACK FOOTER //
// ./components/FormFieldCheckbox/FormFieldCheckbox.js